import React from 'react';
import './App.css';
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import { theme } from "./styles/theme";
import NavSection from "./components/sections/shared/nav/NavSection";
import FooterSection from "./components/sections/shared/footer/FooterSection";
import { LanguageProvider } from "./hooks/LanguageProvider";
import { CartProvider } from "./hooks/useCart";
import { WishlistProvider } from "./hooks/useWishlist";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./components/pages/HomePage";
import ShopPage from "./components/pages/ShopPage";
import ProductPage from "./components/pages/ProductPage";
import CartPage from "./components/pages/CartPage";
import CheckoutDemoPage from "./components/pages/CheckoutDemoPage";
import BlogPage from "./components/pages/BlogPage";
import BlogArticlePage from "./components/pages/BlogArticlePage";
import ContactPage from "./components/pages/ContactPage";
import ImprintPage from "./components/pages/ImprintPage";
import PrivacyPage from "./components/pages/PrivacyPage";
import TermsPage from "./components/pages/TermsPage";
import NotFoundPage from "./components/pages/NotFoundPage";

function App() {
    return (
        <HelmetProvider>
            <ThemeProvider theme={theme}>
                <LanguageProvider>
                    <CartProvider>
                        <WishlistProvider>
                            <CssBaseline />
                            <Box display="flex" flexDirection="column" minHeight="100vh">
                                <Router>
                                    <NavSection />
                                    <Box flex="1">
                                        <Routes>
                                            <Route path="/" element={<HomePage />} />
                                            <Route path="/shop" element={<ShopPage />} />
                                            <Route path="/shop/:category" element={<ShopPage />} />
                                            <Route path="/produkt/:handle" element={<ProductPage />} />
                                            <Route path="/warenkorb" element={<CartPage />} />
                                            <Route path="/checkout-demo" element={<CheckoutDemoPage />} />
                                            <Route path="/blog" element={<BlogPage />} />
                                            <Route path="/blog/:handle" element={<BlogArticlePage />} />
                                            <Route path="/kontakt" element={<ContactPage />} />
                                            <Route path="/contact" element={<ContactPage />} />
                                            <Route path="/impressum" element={<ImprintPage />} />
                                            <Route path="/imprint" element={<ImprintPage />} />
                                            <Route path="/datenschutz" element={<PrivacyPage />} />
                                            <Route path="/privacy" element={<PrivacyPage />} />
                                            <Route path="/agb" element={<TermsPage />} />
                                            <Route path="/terms" element={<TermsPage />} />
                                            <Route path="*" element={<NotFoundPage />} />
                                        </Routes>
                                    </Box>
                                    <FooterSection />
                                </Router>
                            </Box>
                        </WishlistProvider>
                    </CartProvider>
                </LanguageProvider>
            </ThemeProvider>
        </HelmetProvider>
    );
}

export default App;
